import { render } from "./FrontPageDesignNav.vue?vue&type=template&id=4dc4dccc&scoped=true"
import script from "./FrontPageDesignNav.vue?vue&type=script&lang=js"
export * from "./FrontPageDesignNav.vue?vue&type=script&lang=js"

import "./FrontPageDesignNav.vue?vue&type=style&index=0&id=4dc4dccc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc4dccc"]])

export default __exports__